import { useTranslator } from "@eo-locale/react";

import { string } from "yup";

import find from "lodash/find";

import type { PlacesQuestion, Question } from "@/types";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";

import { CommonDropdownQuestion } from "@/storybook-components";

import { setAnswer } from "@/redux/features/place-form/slice";

export const validate = async (
  answer: string,
  question: Question
): Promise<string[]> => {
  let schema = string().nullable();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.validate(answer);
    return [];
  } catch (err) {
    return err.errors;
  }
};

const DropDownQuestionComponent = (props: PlacesQuestion) => {
  const { question, isClearable = true } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { answers, answerErrors } = useAppSelector((state) => state.placesForm);

  const error = answerErrors[question?.id] || "";
  const answer = answers[question?.id] || "";

  const { notes, required, id, questionOptions, question: title } = question;

  const selectedOption = find(
    question.questionOptions.filter((option) => !option.deleted),
    ({ id }) => id === answer
  );

  const answeredOption = selectedOption?.name
    ? { label: selectedOption.name, value: answer }
    : null;

  const handleChange = (e): void => {
    dispatch(
      setAnswer({
        questionId: question.id,
        answer: e?.value ? parseInt(e.value) : null
      })
    );
  };

  return (
    <CommonDropdownQuestion
      isClearable={isClearable}
      answer={answeredOption}
      note={notes}
      errorMessage={error && translate(`errors.${error}`)}
      isRequired={required}
      id={id}
      size="md"
      withErrorIcon={true}
      changeEventHandler={handleChange}
      options={[...questionOptions]
        .filter((option) => !option.deleted)
        .sort((a, b) => a.sequence - b.sequence)
        .map((option) => ({ value: option.id, label: option.name }))}
      spacing={0}
      questionLabel={title}
      isInvalid={error.length}
      answerProps={{
        minHeight: "0.75rem",
        className: "places-dropdown-question"
      }}
      questionLabelProps={{
        marginTop: 6
      }}
    />
  );
};

export default DropDownQuestionComponent;
